<template>
    <div class="review">
        <b-card body-class="p-3" :title="$translate('bulk_reviews')">
            <div class="mt-3">
                <b-row>
                    <b-col cols="12" class="dd">
                        <label for="user-input" class="mb-3"><strong>{{ $translate('review_type') }}</strong></label>
                        <b-form-select class="form-control" id="user-input" v-model="checkoff_type_id"
                            :options="filteredTypes" text-field="name" value-field="id" trim>
                            <template #first>
                                <b-form-select-option :value="null" disabled>{{ $translate('select_review_type')
                                }}</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" class="d-flex justify-content-end align-items-center mt-3">
                        <b-button :disabled="selectedOrders.length == 0" variant="info" class="btn-fw" block
                            @click="doBulkAction">{{ $translate('submit') }}</b-button>
                    </b-col>
                </b-row>
            </div>
            <b-card-body class="p-0 mt-3">
                <b-table id="orderTable" :fields="fields" :busy="loading" :items="relevantOrders" selectable responsive
                    @row-selected="onRowSelected" ref="orderTable">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>{{ $translate('loading') }}</strong>
                        </div>
                    </template>
                    <template #head(id)>
                        <b-form-checkbox v-if="orders.length > 0" :checked="relevantOrders.length === selectedOrders.length"
                            @change="toggleAllRow()"></b-form-checkbox>
                    </template>

                    <template #cell(id)="{ rowSelected, index }">
                        <b-form-checkbox :checked="rowSelected" @change="toggleRow(index, rowSelected)"></b-form-checkbox>
                    </template>

                    <template #cell(custom)="{ item }">
                        <b-button v-if="hasPermissionView" :to="`/ams/activities/${item.id}`" class="mr-2"
                            variant="pink-button" target="_blank">
                            <img src="@/assets/images/icon/view.svg" />
                        </b-button>
                    </template>

                    <template #cell(return_quantity)="row">
                        <b-form-input type="number" v-model="row.item.return_quantity"
                            placeholder="Return Qty"></b-form-input>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
export default {
    name: 'reviews',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        selectedOrders: [],
        checkoff_type_id: null,
        loading: false,

    }),
    computed: {
        fields() {
            return [
                { key: 'id', label: '' },
                { key: 'custom', label: this.$translate('actions') },
                { key: 'reference_no', label: this.$translate('reference_no') },
                { key: 'description', label: this.$translate('description') },
                {
                    key: 'customer',
                    label: this.$translate('customer'),
                    formatter: x => `${(x && x.name) || ''}`,
                },
                {
                    key: 'driver',
                    label: this.$translate('officer'),
                    formatter: x =>
                        `${(x && x.first_name) || ''} ${(x && x.last_name) || ''}`,
                },
                {
                    key: 'type',
                    label: this.$translate('type'),
                    formatter: x => x.name,
                },
            ]
        },
        user() {
            const user = this.$store.state.user
            console.log('user', user)
            return user
        },
        checkoffTypes() {
            const types = this.$store.state.checkoffTypes.types
            console.log('types', types)
            return types
        },
        filteredTypes() {
            const _types = []
            console.log('user.roles', this.user.roles)
            for (let type of this.checkoffTypes) {
                for (let type_role of type.checkoff_type_roles) {
                    console.log('type_role', type_role)
                    if (
                        this.user.roles.some(
                            user_role => user_role.role_id === type_role.role_id
                        )
                    ) {
                        _types.push(type)
                    }
                }
            }
            console.log(_types, "_types");
            return _types
        },
        orders() {
            return this.$store.state.orders.items
        },
        relevantOrders() {
            const { checkoff_type_id } = this
            console.log("relevantOrders", this.orders);
            return this.orders.filter(x => {
                if (!x.checkoff_template_id) return false
                console.log('x.checkoffs', x.checkoffs)
                const checkoffs = x.checkoffs || []
                const _selectedCheckoff = checkoffs.find(
                    x => x.checkoff_type_id == checkoff_type_id
                )
                console.log('_selectedCheckoff', _selectedCheckoff)
                if (checkoffs.length === 0) return false
                if (!_selectedCheckoff) return false
                if (_selectedCheckoff.completed == 1) return false
                if (_selectedCheckoff.sequence_no == 1) return true
                if (checkoffs.length === 1) return true
                return !checkoffs.some(
                    x => {
                        console.log(x.id, _selectedCheckoff.id, x.completed, x.sequence_no < _selectedCheckoff.sequence_no, "sequence_no");
                        return (x.id != _selectedCheckoff.id &&
                            x.sequence_no < _selectedCheckoff.sequence_no &&
                            x.completed == 0)
                    }
                )
            })
        },
    },
    watch: {
        orders: {
            immediate: false,
            handler: function () {
                this.loading = false
            }
        },
        checkoff_type_id: function (val) {
            this.loading = true
            this.fetchOrders(val)
        },
    },
    created() {
        this.$store.dispatch('checkoffTypes/fetchAll')
    },
    mounted() {
        console.log('mounted --user', this.user)
        this.fetchOrders()
    },
    methods: {
        onRowSelected(items) {
            this.selectedOrders = items
        },
        selectAllRows() {
            this.$refs.orderTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.orderTable.clearSelected()
        },
        toggleRow(index, rowSelected) {
            // Rows are indexed from 0, so the third row is index 2
            if (rowSelected) this.$refs.orderTable.unselectRow(index)
            else this.$refs.orderTable.selectRow(index)
        },

        toggleAllRow() {
            if (this.relevantOrders.length === this.selectedOrders.length)
                this.$refs.orderTable.clearSelected()
            else this.$refs.orderTable.selectAllRows()
        },
        ///////////////////////////////
        fetchOrders(val = this.checkoff_type_id) {
            console.log(val)
            if (val) this.$store.dispatch('orders/selectCheckoffOrders', val)
            else {
                this.$store.commit('orders/SET_ORDERS', [])
            }
        },

        async doBulkAction() {
            console.log('selectedOrders', this.selectedOrders)
            const title = this.$translate('clear_action')
            const message = this.$translate(`clear_action_note`)
            const result = await this.confirmMessage(title, message)
            if (!result) throw new Error()

            const orders = this.selectedOrders.map(x => x.id)
            const { checkoff_type_id } = this
            console.log('orders--checkoff_type_id', checkoff_type_id)
            console.log('orders--tests', orders)
            await this.$store.dispatch('orders/bulkCheckoffOrders', {
                orders,
                checkoff_type_id,
            })
            this.doToast(
                this.$translate('success'),
                this.$translate('selected_order_clear'),
                'success'
            )
            this.clearSelected()
            this.fetchOrders()
        },
    },
}
</script>
